import 'css-chunk:src/app/containers/Onboarding/OnboardingWizard/steps/Objective/styles.scss';export default {
  "brandCategory": "_brandCategory_1je6k_1"
};